// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"36":"c3873c71","420":"87ede7a0","500":"26054df0"}[chunkId] + ".js";
};